import React from "react";
import "./projects_table.scss";
import WindProject from "../../assets/img/accordian_operation/wind-project.png";
import WindProject2 from "../../assets/img/accordian_operation/wind-project-2.png";
import projects_img from "../../assets/img/projects_img.png";


const windProjects = [
  { 
    "type": "Wind",
    "image": WindProject,
    "location": "Gadag, Karnataka",
    "link": "",
    "capacity": "300",
    "status": "Commissioned",
  }, {
    "type": "Wind",
    "image": WindProject2,
    "location": "Gujarat",
    "link": "",
    "capacity": "141.9",
    "status": "Commissioned"
  }
]


export const ProjectsAccordian = () => {
  return (
    <div>
      <section>
        <div className="container">
          <div className="row text-center pos_relative">
            <center>
              <div className="title pt-4">
                <h4>Projects</h4>
              </div>
            </center>
          </div>
          <div className="table-responsive">
            <table className="table table-striped ">
              <thead>
                <tr className="tableRow">
                  <th>S.No</th>
                  <th>Project Image</th>
                  <th>Project Type</th>
                  <th>Location</th>
                  <th>Capacity (MW AC)</th>
                  <th>Project Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  windProjects.map((project, index) => (
                    <tr>
                    <td> { index + 1} </td>
                    <th>
                      <img src={project?.image} alt="" />
                    </th>
                    <th>Wind</th>
                    <td>
                      {/* { project?.link ? <a href={project?.link}> {project?.location} </a> 
                                      : <span> {project?.location} </span>  
                    } */}
                    <span> {project?.location} </span>
                    </td>
                    <td> { project?.capacity } </td>
                    <td> {project?.status}  </td>
                  </tr>
                  ))
                }
       
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectsAccordian;
